export default __webpack_public_path__ + "static/media/preview.22daa521.png";